import { render, staticRenderFns } from "./VFormInputCheckbox.vue?vue&type=template&id=615c081c&scoped=true&"
import script from "./VFormInputCheckbox.vue?vue&type=script&lang=js&"
export * from "./VFormInputCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./VFormInputCheckbox.vue?vue&type=style&index=0&id=615c081c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615c081c",
  null
  
)

export default component.exports